import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fd72220"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex",
  style: {"width":"500px"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = { class: "mb-10 mt-10" }
const _hoisted_4 = { class: "descriptionsTop" }
const _hoisted_5 = { class: "descriptionsTop" }
const _hoisted_6 = { class: "descriptionsTop" }
const _hoisted_7 = { class: "descriptionsTop" }
const _hoisted_8 = { class: "descriptionsTop" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("调休假剩余 ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("(鼠标移动查看详情) ")
const _hoisted_12 = { class: "descriptionsTop" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("日期代表当前月的月底过期，当月加班系统会自动延期一个月")

import { ref, reactive, onBeforeMount, computed } from 'vue'
import { useStore } from 'vuex'
import tbMix from '@/global_mixin/tableMixin'
import dayjs from 'dayjs'
import Api from '@/http/modules/index'
import { ElMessage, ElMessageBox } from 'element-plus';
import { categoryType,overtimeNatureType} from '@/views/typeMapping/AttendanceMap'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
let {
  // 根据条件获取假期余额人员列表
  'POST/checkin_balances/user/list': fetchList,
  // 根据用户id或日期范围获取假期历史明细
  'POST/checkin_balances/user/history': checkinDeatils,
  'GET/users/list': userListApi,
  // 加班换薪修改(更新年假加班假)
  'PATCH/checkin_balances': checkin_balancesModifyApi,
  // 删除年假加班假
  'DELETE/checkin_balances/{id}': checkin_balancesDelApi,
  // 加班管理列表
  'POST/checkin_balances/overtime/list': overtimeListApi,
  // 获取单个详情 
  'GET/checkin_approvals/id':checkinApprovalsApi

} = Api

const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

const searchConfig = ref([

  {
    type: "TIME",
    label: "日期",
    value: [],
    upKey: '_date',
    upProps: { includeKey: 'dateRange' },
    props: {
      type: 'daterange',
      'value-format': 'YYYY-MM-DD',
      clearable: true,
    }
  }
])
const searchObj = reactive({
  dateRange: []
})

const {
  MI_tableData: detailsData, fetchData: detailsFetch, page: detailsPage, size: detailsSize, MI_params: detailsParams,
  MI_total: detailsTotal, MI_pageChange: detailsPageCg, MI_identify: detailsIdentify, MI_sizeChange: detailsSizeCg
} = new tbMix(checkinDeatils)
// 详情
let detailsRow: any = reactive({})

const searchHandle = async () => {
  let { detail } = await detailsFetch({
    userId: store.getters.userId,
    dateRange: {
      from: searchObj.dateRange?.[0],
      to: searchObj.dateRange?.[1]
    }
  })
  Object.assign(detailsRow, detail)
}
searchHandle()



// ------------
const tableRowClassName = ({ row, rowIndex }: { row: any, rowIndex: number }) => {
  if (row.locked === true) {
    return 'gray-row'
  }
  if (row.operate === true) {
    return 'green-row'
  }
  if (row.operate === false) {
    return 'red-row'
  }
  return ''
}

const merge = (prop: string, oriArr?: any) => {
  let spanCellArr: any = [];
  let concatCell = 0;
  detailsData.value.map((row, index) => {
    if (index === 0) {
      spanCellArr.push(1);
      return ''
    }
    if (row[prop] === detailsData.value[index - 1][prop]) {
      spanCellArr[concatCell] += 1
      spanCellArr.push(0)
    } else {
      spanCellArr.push(1)
      concatCell = index
    }

    return ''
  })

  // 二次排序
  if (oriArr) {
    let stepNum = 0
    return spanCellArr.reduce((arr: number[], _spanCell: number, index: number) => {
      if (_spanCell < oriArr[index]) {
        oriArr[_spanCell + index] = oriArr[index] - _spanCell
        arr.push(_spanCell)
        return arr
      }

      if (_spanCell > oriArr[index]) {
        spanCellArr[index + 1] = _spanCell - oriArr[index]
        arr.push(oriArr[index])
        return arr
      }
      // 相等
      arr.push(_spanCell)
      return arr
    }, [])
  }


  return spanCellArr
}

// 对比排序
const dateHeadArr = computed(() => {
  // return merge('date')
  return merge('operate', merge('date'))
})


const objectSpanMethod = ({ row, column, rowIndex, columnIndex }: any) => {


  if (columnIndex === 0) {

    const _row = dateHeadArr.value[rowIndex]
    // const _row = merge('date')[rowIndex]
    const _col = _row > 0 ? 1 : 0
    return {
      rowspan: _row,
      colspan: _col,
    }
  }
}

// 显示详情
const holidayDetail=ref<any >({})
const holidayDetailVisiable=ref(false)
const showHolidayDetail=(row:any,)=>{  
  if(!row.approvalId){
    ElMessage.warning("该条记录无详情！")
    return
  }
  checkinApprovalsApi({id:row.approvalId}).then((res:any)=>{
    holidayDetail.value=res
    holidayDetailVisiable.value=true
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_date_picker, {
        modelValue: _unref(searchObj).dateRange,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).dateRange) = $event)),
        disabled: _unref(detailsIdentify),
        "value-format": "YYYY-MM-DD",
        type: "daterange",
        clearable: "",
        "range-separator": "至",
        "start-placeholder": "开始日期",
        onChange: searchHandle,
        "end-placeholder": "结束日期"
      }, null, 8, ["modelValue", "disabled"]),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (searchHandle())),
        disabled: _unref(detailsIdentify),
        class: "ml-10"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_descriptions, {
        title: "",
        border: "",
        column: 5
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, { label: "姓名" }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(detailsRow).realName || '-'), 1),
              _createElementVNode("p", null, _toDisplayString(_unref(detailsRow).alias || '请选择员工'), 1)
            ]),
            _: 1
          }),
          (_unref(detailsRow).freedomDisplay)
            ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                key: 0,
                label: "季度自由度剩余额度"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_5, _toDisplayString(((_unref(detailsRow).surplusFreedomLimit || 0) * 8 ).toFixed(1)) + "小时", 1),
                  _createElementVNode("p", null, _toDisplayString(_unref(detailsRow).surplusFreedomLimit || '0') + "天", 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_descriptions_item, { label: "年假剩余" }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_6, _toDisplayString(((_unref(detailsRow).annualDay || 0) * 8 ).toFixed(1)) + "小时", 1),
              _createElementVNode("p", null, _toDisplayString(_unref(detailsRow).annualDay || '0') + "天", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "待生效年假额度" }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_7, _toDisplayString(((_unref(detailsRow).surplusLimit || 0) * 8 ).toFixed(1)) + "小时", 1),
              _createElementVNode("p", null, _toDisplayString(_unref(detailsRow).surplusLimit || '0') + "天", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "当前月调休假待逾期" }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(detailsRow).overdueHour || '0') + "小时", 1),
              _createElementVNode("p", null, _toDisplayString((_unref(detailsRow).overdueHour || 0) / 8) + "天", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "调休假剩余" }, {
            label: _withCtx(() => [
              _createVNode(_component_el_popover, {
                width: 250,
                placement: "right",
                trigger: "hover"
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    style: {"font-weight":"700"},
                    link: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9,
                      _hoisted_10,
                      _hoisted_11
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_form, {
                    class: "time-form",
                    "label-width": "160",
                    "label-position": "left"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "总时长：" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(detailsRow).adjust?_unref(detailsRow).adjust.totalTime : '0') + "小时", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "日常加班-工作日：" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(detailsRow).adjust?_unref(detailsRow).adjust.dailyWorkTime : '0') + "小时", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "日常加班-周末：" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(detailsRow).adjust?_unref(detailsRow).adjust.dailyHolidayTime : '0') + "小时", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "日常加班-法定节假日：" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(detailsRow).adjust?_unref(detailsRow).adjust.dailyFestivalTime : '0') + "小时", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "项目加班-工作日：" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(detailsRow).adjust?_unref(detailsRow).adjust.projectWorkTime : '0') + "小时", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "项目加班-周末：" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(detailsRow).adjust?_unref(detailsRow).adjust.projectHolidayTime : '0') + "小时", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "项目加班-法定节假日：" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(detailsRow).adjust?_unref(detailsRow).adjust.projectFestivalTime : '0') + "小时", 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(detailsRow).adjust?_unref(detailsRow).adjust.totalTime : '0') + "小时", 1),
              _createElementVNode("p", null, _toDisplayString((_unref(detailsRow).adjust?_unref(detailsRow).adjust.totalTime : 0) / 8) + "天", 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_tag, {
      class: "mb-10",
      type: "warning",
      style: {"fontSize":"16px"}
    }, {
      default: _withCtx(() => [
        _hoisted_13
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      class: "tr-cursor-pointer",
      onRowDblclick: showHolidayDetail,
      "span-method": objectSpanMethod,
      border: "",
      data: _unref(detailsData),
      "max-height": 575 + 'px',
      "row-class-name": tableRowClassName
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "日期",
          prop: "date",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "类型",
          prop: "category"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(row.overtimeNature?_unref(categoryType)[row.category]+'-' + _unref(overtimeNatureType)[row.overtimeNature] :_unref(categoryType)[row.category]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "小时",
          prop: ""
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(row.operate ? row.time : '-' + row.time), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作时间",
          prop: "createdAt",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(_unref(dayjs)(row.createdAt).format('YYYY-MM-DD HH:mm')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作人",
          prop: "operator"
        }),
        _createVNode(_component_el_table_column, {
          label: "更新人",
          prop: "updatedBy"
        }),
        _createVNode(_component_el_table_column, {
          label: "更新时间",
          prop: "updatedAt",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(row.updatedAt ? _unref(dayjs)(row.updatedAt).format('YYYY-MM-DD HH:mm') : ''), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "事由",
          prop: "note",
          "show-overflow-tooltip": ""
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _unref(detailsIdentify)]
    ]),
    _createVNode(_component_el_pagination, {
      small: "",
      background: "",
      total: _unref(detailsTotal),
      currentPage: _unref(detailsPage),
      "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => (_isRef(detailsPage) ? (detailsPage).value = $event : null)),
      "page-size": _unref(detailsSize),
      "onUpdate:page-size": _cache[3] || (_cache[3] = ($event: any) => (_isRef(detailsSize) ? (detailsSize).value = $event : null)),
      class: "mb-5 mt-5",
      "page-sizes": [10, 30, 50,],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(detailsPageCg),
      onSizeChange: _unref(detailsSizeCg)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      modelValue: holidayDetailVisiable.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((holidayDetailVisiable).value = $event)),
      title: "",
      width: "500"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_descriptions, {
          class: "holiday-detail-des",
          column: 1,
          title: `${holidayDetail.value.alias} (${holidayDetail.value.realName})的${holidayDetail.value.spName=='加班'?'加班':'请假'}`
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "审批编号：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(holidayDetail.value.spNo), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "请假类型：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(holidayDetail.value.spName), 1)
              ]),
              _: 1
            }),
            (holidayDetail.value.spName=='加班')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_el_descriptions_item, { label: "加班事由：" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(holidayDetail.value.note), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "加班类型：" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(holidayDetail.value.firstSelector), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "加班性质：" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(holidayDetail.value.selector), 1)
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_el_descriptions_item, { label: "开始时间：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(holidayDetail.value.newBegin), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "结束时间：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(holidayDetail.value.newEnd), 1)
              ]),
              _: 1
            }),
            (holidayDetail.value.spName!='加班')
              ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                  key: 1,
                  label: "请假时长："
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(holidayDetail.value.time+ `小时(${holidayDetail.value.state==1?'系统计算':'用户修改'})`), 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_descriptions_item, {
                  key: 2,
                  label: "加班时长："
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(holidayDetail.value.time+ `小时(${holidayDetail.value.state==1?'系统计算':'用户修改'})`), 1)
                  ]),
                  _: 1
                })),
            (holidayDetail.value.spName!='加班')
              ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                  key: 3,
                  label: "请假事由："
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(holidayDetail.value.note), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_descriptions_item, { label: "审批人：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(holidayDetail.value.approverName?holidayDetail.value.approverName.join(','):""), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})